import { render, staticRenderFns } from "./PartnerOrders.vue?vue&type=template&id=0a1b3c10&scoped=true"
import script from "./PartnerOrders.vue?vue&type=script&lang=js"
export * from "./PartnerOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b3c10",
  null
  
)

export default component.exports